import React from 'react';

const HerosDiscountFormWidget = (props: any) => {
  return (
    <div className="HeroFormHeader-container">
      <div className="container">
        <div className="HeroesFormWidget-content">
          <div>
            <div dangerouslySetInnerHTML={{ __html: props.data?.description }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HerosDiscountFormWidget;